import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { RecordsCoudPouce } from '@classes/records/record';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faHistory, faInfoCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ConvertDateService } from '@services/convert-date/convert-date.service';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { HistoryComponent } from '../history/history.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends SubscriptionBaseComponent implements OnInit {

  faHistory = faHistory;
  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faArrowCircleLeft = faArrowAltCircleLeft;
  faArrowCircleRight = faArrowAltCircleRight;

  navTimeActive: string = null;

  dashboardForm: FormGroup;

  progressContainer = 66;
  showValue = false;
  recordsList: RecordsCoudPouce[];
  sortValueRecords: string;
  paginationRecords: Pagination;

  options = ['Générique', 'Sélection', 'Beauaime'];
  selectFC: string;

  date = new Date();
  year = this.date.getFullYear();
  month = this.date.getMonth();
  arrayMonth = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  leapYear = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  noLeapYear = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  numberDayOfMonth = 0;
  filterValueRecords: { username: any; step: any; category: any; dateFrom: any; dateTo: any; } = null;
  legendFc = [
    {
      name: 'Homme',
      color: '#7fcff7'
    },
    {
      name: 'Femme',
      color: '#ff9ebd'
    },
    {
      name: 'Enfant',
      color: '#ffe7a2'
    },
    {
      name: 'Chaussure/Accesoire',
      color: '#aaffa2'
    },
  ];

  constructor(
    private dialog: MatDialog,
    private recordsService: RecordsService,
    private convertDateService: ConvertDateService,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.dataService.selectFC$.next('Générique');
    this.initform();
    this.initSub();


    // this.initProgressContainer();
  }

  openDialogHistoryContainer(): void {
    const dialogRef = this.dialog.open(HistoryComponent);
  }

  onSubmit(origin: string): void {
    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    const from = this.dashboardForm.get('from').value;
    const to = this.dashboardForm.get('to').value;



    if (from) {
      this.filterValueRecords.dateFrom = this.convertDateService.convertDate(from);
    }

    if (to) {
      this.filterValueRecords.dateTo = this.convertDateService.convertDate(to, true);
    }

    switch (origin) {
      case 'submit':
        this.getRecordsWithFilterReturnFirstPage();
        break;
      case 'export':
        this.getFileForExportRecords();
        break;
      default:
        break;
    }

  }

  changeMonth(direction: string): void {
    let dateFrom = new Date();
    this.numberDayOfMonth = 0;
    let dateTo = new Date();

    switch (direction) {
      case ('previous'):
        this.month === 0 ? (this.month = 12, this.year--) : this.month = this.month;
        this.month--;
        dateFrom = new Date(this.year, this.month, 1);

        (this.year % 4 !== 0 || this.year % 100 === 0 && this.year % 400 !== 0) ?
          this.numberDayOfMonth = this.noLeapYear[this.month] :
          this.numberDayOfMonth = this.leapYear[this.month];
        dateTo = new Date(this.year, this.month, this.numberDayOfMonth);

        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);

        break;
      case ('next'):
        this.month === 11 ? (this.month = -1, this.year++) : this.month = this.month;
        this.month++;
        dateFrom = new Date(this.year, this.month, 1);

        (this.year % 4 !== 0 || this.year % 100 === 0 && this.year % 400 !== 0) ?
          this.numberDayOfMonth = this.noLeapYear[this.month] :
          this.numberDayOfMonth = this.leapYear[this.month];

        dateTo = new Date(this.year, this.month, this.numberDayOfMonth);
        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);

        break;
      default:
        break;
    }
    this.getRecordsWithFilterReturnFirstPage();
  }

  changeYear(direction: string): void {
    let dateFrom = new Date();
    let dateTo = new Date();
    switch (direction) {
      case ('previous'):
        this.year--;
        dateFrom = new Date(this.year, 0, 1);
        dateTo = new Date(this.year, 11, 31);

        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);
        break;
      case ('next'):
        this.year++;
        dateFrom = new Date(this.year, 0, 1);
        dateTo = new Date(this.year, 11, 31);

        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);

        break;
      default:
        break;
    }
    this.getRecordsWithFilterReturnFirstPage();

  }

  selectTab(tab: string): void {
    this.dataService.typeTime$.next(tab);
    let dateFrom = new Date();
    let dateTo = new Date();

    switch (tab) {
      case 'year':
        dateFrom = new Date(this.year, 0, 1);
        dateTo = new Date(this.year, 11, 31);

        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);

        break;

      case 'month':
        dateFrom = new Date(this.year, this.month, 1);
        this.numberDayOfMonth = 0;

        (this.year % 4 !== 0 || this.year % 100 === 0 && this.year % 400 !== 0) ?
          this.numberDayOfMonth = this.noLeapYear[this.month] :
          this.numberDayOfMonth = this.leapYear[this.month];

        dateTo = new Date(this.year, this.month, this.numberDayOfMonth);

        this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
        this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);

        break;

      default:
        break;
    }

    this.getRecordsWithFilterReturnFirstPage();

  }

  updateSelectFC(event): void {
    this.dataService.selectFC$.next(event.value);
  }

  private getRecordsWithFilterReturnFirstPage(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      1,
      null
    );
    this.recordsService.getRecords(newRequest);
  }

  getFileForExportRecords(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      this.paginationRecords.pageNumber,
      this.paginationRecords.totalRecords
    );

    this.recordsService.exportRecords(newRequest);
  }
  // private initProgressContainer(): void {
  //   const progress = document.getElementById('progress');
  //   progress.style.width = '0';
  //   setTimeout(() => {

  //     progress.style.width = this.progressContainer.toString() + '%';
  //   }, 500);
  //   setTimeout(() => {
  //     this.showValue = true;
  //   }, 600);

  // }

  private initSub(): void {


    this.numberDayOfMonth = 0;
    this.month = new Date().getMonth();

    (this.year % 4 !== 0 || this.year % 100 === 0 && this.year % 400 !== 0) ?
      this.numberDayOfMonth = this.noLeapYear[this.month] :
      this.numberDayOfMonth = this.leapYear[this.month];


    const dateFrom = new Date(this.year, this.month, 1);
    const dateTo = new Date(this.year, this.month, this.numberDayOfMonth);


    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());
    this.filterValueRecords.dateTo = this.convertDateService.convertDate(dateTo.toString(), true);
    // this.filterValueRecords.dateTo = '2021-07-01T00:00:00.000Z';

    this.getRecordsWithFilterReturnFirstPage();

    this.recordsService.getRecords(new PaginationRequest(this.filterValueRecords, this.sortValueRecords, 1));
    this.subscription
      .add(
        this.recordsService.eventsListSubject
          .subscribe(events => {
            this.recordsList = events?.body;
            this.paginationRecords = events?.pagination;
            this.cdr.detectChanges();


          })
      )
      .add(
        this.dataService.typeTime$.subscribe(typeTime => {
          this.navTimeActive = typeTime;
          this.cdr.detectChanges();

        })
      )
      .add(
        this.dataService.selectFC$.subscribe({
          next: selectFC => this.selectFC = selectFC
        })
      );



  }

  private initform() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDateofMonth = new Date(year, month, 1);

    this.dashboardForm = this.formBuilder.group({
      from: [firstDateofMonth],
      to: [today]
    });
  }

}
